@if (!userLoggedIn || (userLoggedIn && (!userInfo?.webEnabled))) {
  <ng-container class="Lo-tiles">
    @if (uklocontactnode | async; as data) {
      <div class="Support_lowerboxsUK container-lg container-fluid">
        <div class=" padding-L40 sub-containerUK">
          @for (item of mergedObject1; track item; let i = $index) {
            <div class="Support_flu360 col-lg-4 col-md-4 col-sm-12 col-xs-12 no-padding padding-R20" [ngClass]="{'Support_adverseReporting': i === 1,'Support_medicalCommunication': i === 2}">
              <h4 class="Support_flu360header boxHeader" [ngClass]="{'Support_adverseReportingheader': i === 1}">{{item?.headLine}}</h4>
              <div class="Support_flu360Content boxContent" [ngClass]="{'Support_adverseReportingContent': i === 1}">{{item?.content}}</div>
              <div class="Support_email" [innerHTML]="item?.t1content"></div>
              <div class="Support_call" [innerHTML]="item?.t2content"></div>
            </div>
          }
          <div class="clearboth"></div>
        </div>
      </div>
    }
  </ng-container>
}